import { messages } from "@/shared/i18n";
import { cn } from "@/shared/lib/cn";

interface LogoProps {
  /** Sizing/spacing utilities. Always set a height (e.g. `h-9`); width stays auto. */
  className?: string;
}

/**
 * Product logo.
 *
 * SKIN: rebrand by swapping the asset at `public/logo.svg` (same path) — no code
 * change needed, mirroring the favicon/legal-PDF pattern. Sized by height so any
 * logo aspect ratio stays intact (`w-auto` + `max-w-full` guard against overflow).
 * The accessible name comes from the swappable `common.appName` i18n string.
 */
export function Logo({ className }: LogoProps) {
  return (
    <img
      alt={messages.common.appName}
      className={cn("h-9 w-auto max-w-full select-none", className)}
      draggable={false}
      src="/logo.svg"
    />
  );
}
